import { StyleSheet } from 'react-native-unistyles'

const modalStyles = StyleSheet.create((theme) => ({
  body: {
    color: theme.colors.onSurfaceVariant,
    lineHeight: 24,
    marginBottom: theme.tokens.spacing[4],
    marginHorizontal: theme.tokens.spacing[1],
    textAlign: 'center',
  },
  buttonContent: {
    paddingVertical: theme.tokens.spacing[2],
  },
  card: {
    alignSelf: 'center',
    backgroundColor: theme.colors.surface,
    borderRadius: theme.tokens.containerBorderRadius * 2,
    maxWidth: 400,
    paddingHorizontal: theme.tokens.spacing[5],
    paddingVertical: theme.tokens.spacing[6],
    shadowColor: theme.colors.shadow,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 16,
    width: '90%',
  },
  logo: {
    alignSelf: 'center',
    height: 64,
    marginBottom: theme.tokens.spacing[4],
    marginTop: theme.tokens.spacing[2],
    opacity: 0.95,
    width: 64,
  },
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: theme.tokens.spacing[4],
    paddingVertical: theme.tokens.spacing[8],
  },
  primaryButton: {
    borderRadius: 100,
    justifyContent: 'center',
    marginBottom: theme.tokens.spacing[2],
    marginTop: theme.tokens.spacing[1],
    minHeight: 48,
  },
  scrollContent: {
    alignItems: 'center',
    paddingBottom: theme.tokens.spacing[2],
  },
  scrollView: {
    maxHeight: '100%',
  },
  textButton: {
    borderRadius: 100,
    justifyContent: 'center',
    marginBottom: theme.tokens.spacing[1],
    minHeight: 44,
  },
  title: {
    color: theme.colors.onSurface,
    fontWeight: 'bold',
    marginBottom: theme.tokens.spacing[5],
    marginTop: theme.tokens.spacing[1],
    textAlign: 'center',
  },
}))

const useModalStyles = () => {
  const getModalProps = () => ({
    contentContainerStyle: modalStyles.scrollContent,
    showsVerticalScrollIndicator: false,
    style: modalStyles.scrollView,
  })

  return {
    styles: modalStyles,
    getModalProps,
    // Common modal configuration
    modalConfig: {
      maxWidth: 400,
      scrollViewMaxHeight: '70%',
    },
  }
}

export default useModalStyles
